"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlexColumn = exports.FlexRow = void 0;
const react_1 = __importDefault(require("react"));
class FlexRow extends react_1.default.Component {
    render() {
        return react_1.default.createElement("div", Object.assign({}, this.props, { style: Object.assign(Object.assign({}, this.props.style), { display: "flex", flexDirection: "row" }) }), this.props.children);
    }
}
exports.FlexRow = FlexRow;
class FlexColumn extends react_1.default.Component {
    render() {
        return react_1.default.createElement("div", Object.assign({}, this.props, { style: Object.assign(Object.assign({}, this.props.style), { display: "flex", flexDirection: "column" }) }), this.props.children);
    }
}
exports.FlexColumn = FlexColumn;
//# sourceMappingURL=layout.js.map